import { trackElementInteraction } from '../util/analytics'

up.compiler('[data-track-element-visibility]', (element: HTMLElement) => {
  const elementId = element.getAttribute('up-id')
  const selector = `[up-id="${elementId}"]`
  const observer = new IntersectionObserver(trackEventOnIntersection)
  observer.observe(document.querySelector(selector)!)

  function trackEventOnIntersection(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ): void {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        trackElementInteraction(element, 'element.visible')
        observer.unobserve(entry.target)
      }
    })
  }
})
